<ng-container
    msScrolledToBottom
    toleranceType="relative"
    scrollContext="document"
    *ngIf="live | async as gridModel; else error"
    [toleranceValue]="0.5"
    (scrollAtBottom)="scrolledBottom()">
    <div class="grid-wrapper">
        <ms-grid
            sortingTracking="Live"
            [model]="gridModel"
            [tracking]="tracking"
            [hideTitle]="true"
            [selectedTabSportId]="sport"
            (groupToggle)="liveGroupToggled()" />
        <ms-live-grid-footer *ngIf="main" [model]="main" />

        <div class="grid-footer ms-active-highlight" *ngIf="showMore" (click)="scrolledBottom()">
            <div [class.spinner-img]="isLoading">{{ sitecore.event.MoreEvents }}</div>
        </div>
    </div>
    <ms-banner [position]="'LobbyMiddleBanner'" [pageName]="'LiveSport'" />
    <ms-live-upcoming-list *ngIf="upcomingLoaded && upcoming" [loadOnScroll]="true" [model]="upcoming" [tracking]="tracking" />
</ng-container>
<ng-template #error>
    <ms-error severity="info" [message]="sitecore.event.ErrNoEvents" />
</ng-template>
